import { useMemo } from 'react';
import { useParams } from 'react-router';
import { DEFAULT_STUDIO_CATEGORY_SLUG } from '../config';
import { useSearchParams } from 'react-router-dom';

export function useParamsWithDefaults() {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const criteria = searchParams.get('criteria');
  return useMemo(
    () => ({
      categorySlug: criteria ? undefined : DEFAULT_STUDIO_CATEGORY_SLUG,
      ...params,
    }),
    [params, criteria],
  );
}
